import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import {
  getJob,
  decodeJobContent,
  SMAVA_BOARD_NAME,
} from '../../../lib/greenHouse/greenHouseApi';

const StyledButton = styled(Button)`
  margin: 1rem 1rem 2rem 0rem;
`;

const JobDetailContainer = styled('div')`
  margin: 1rem;
`;

const BackButton = styled(Button)(({ theme }) => ({
  margin: '1rem 1rem 2rem 0rem',
  backgroundColor: theme.palette.grey[800],
  ['&:hover']: {
    backgroundColor: theme.palette.grey[300],
  },
}));

export const JobDetails = ({
  applicationLinkHandler,
  backLinkHandler,
  jobId,
}: {
  applicationLinkHandler: any;
  backLinkHandler: any;
  jobId: string;
}): JSX.Element => {
  const [job, setJob] = useState<any>(null);

  useEffect(() => {
    // Create an scoped async function in the hook
    async function getJobAndSetState() {
      setJob(await getJob(SMAVA_BOARD_NAME, jobId));
    }
    // Execute the created function directly
    getJobAndSetState();
  }, [jobId]);

  return (
    <Container maxWidth="lg">
      {job ? (
        <JobDetailContainer>
          <BackButton
            variant="contained"
            color="secondary"
            onClick={backLinkHandler}
          >
            Zurück
          </BackButton>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={applicationLinkHandler}
          >
            Jetzt bewerben
          </StyledButton>

          <div
            id="job-details"
            dangerouslySetInnerHTML={{ __html: decodeJobContent(job.content)! }}
          />

          <BackButton
            variant="contained"
            color="secondary"
            onClick={backLinkHandler}
          >
            Zurück
          </BackButton>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={applicationLinkHandler}
          >
            Jetzt bewerben
          </StyledButton>
        </JobDetailContainer>
      ) : (
        <JobDetailContainer>
          <Typography variant="h4">Loading...</Typography>
        </JobDetailContainer>
      )}
    </Container>
  );
};
